import React from "react";
import { Smartphone } from "lucide-react";
import { PLAY_STORE_URL } from "@/lib/seo";

/** Shared Google Play link for Android app download placements. */
export default function ApkDownloadButton({ className = "", label = "Google Play", icon = true }) {
  return (
    <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className={className} data-testid="apk-download-button">
      <span className="flex items-center justify-center gap-1.5">
        {icon && <Smartphone className="w-3.5 h-3.5" />}{label}
      </span>
    </a>
  );
}
